import { Record, List } from 'immutable';

const {
    START_SESSION_REQUEST,
    START_SESSION_SUCCESS,
    START_SESSION_FAILURE,

    END_SESSION_REQUEST,
    END_SESSION_SUCCESS,
    END_SESSION_FAILURE,

    SEND_HEARTBEAT_REQUEST,
    SEND_HEARTBEAT_SUCCESS,
    SEND_HEARTBEAT_FAILURE,

    TRACK_PAGE_VIEW_REQUEST,
    TRACK_PAGE_VIEW_SUCCESS,
    TRACK_PAGE_VIEW_FAILURE,

    SEND_PAGE_VIEWS_BATCH_REQUEST,
    SEND_PAGE_VIEWS_BATCH_SUCCESS,
    SEND_PAGE_VIEWS_BATCH_FAILURE,

    TRACK_EVENT_REQUEST,
    TRACK_EVENT_SUCCESS,
    TRACK_EVENT_FAILURE,

    SEND_EVENTS_BATCH_REQUEST,
    SEND_EVENTS_BATCH_SUCCESS,
    SEND_EVENTS_BATCH_FAILURE,

    QUEUE_PAGE_VIEW,
    QUEUE_EVENT,
    CLEAR_PAGE_VIEW_QUEUE,
    CLEAR_EVENT_QUEUE,

    SET_CURRENT_PAGE,
    CLEAR_CURRENT_PAGE,

    SET_SESSION_ID,
    CLEAR_SESSION,
} = require('./analyticsActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
    sessionId: null,
    sessionStartedAt: null,
    currentPage: null,
    pageStartTime: null,
    pageViewQueue: List([]),
    eventQueue: List([]),
});

const initialState = new InitialState();

export default function analyticsReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    // Session management
    case START_SESSION_REQUEST:
    case END_SESSION_REQUEST:
    case SEND_HEARTBEAT_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case START_SESSION_SUCCESS:
        return state.set('isFetching', false)
            .set('sessionId', payload?.data?.session_id || null)
            .set('sessionStartedAt', new Date().toISOString());

    case END_SESSION_SUCCESS:
        return state.set('isFetching', false)
            .set('sessionId', null)
            .set('sessionStartedAt', null)
            .set('currentPage', null)
            .set('pageStartTime', null);

    case SEND_HEARTBEAT_SUCCESS:
        return state.set('isFetching', false);

    case START_SESSION_FAILURE:
    case END_SESSION_FAILURE:
    case SEND_HEARTBEAT_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    // Page view tracking
    case TRACK_PAGE_VIEW_REQUEST:
    case SEND_PAGE_VIEWS_BATCH_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case TRACK_PAGE_VIEW_SUCCESS:
    case SEND_PAGE_VIEWS_BATCH_SUCCESS:
        return state.set('isFetching', false);

    case TRACK_PAGE_VIEW_FAILURE:
    case SEND_PAGE_VIEWS_BATCH_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    // Event tracking
    case TRACK_EVENT_REQUEST:
    case SEND_EVENTS_BATCH_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case TRACK_EVENT_SUCCESS:
    case SEND_EVENTS_BATCH_SUCCESS:
        return state.set('isFetching', false);

    case TRACK_EVENT_FAILURE:
    case SEND_EVENTS_BATCH_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    // Queue management
    case QUEUE_PAGE_VIEW:
        return state.set('pageViewQueue', state.get('pageViewQueue').push(payload));

    case QUEUE_EVENT:
        return state.set('eventQueue', state.get('eventQueue').push(payload));

    case CLEAR_PAGE_VIEW_QUEUE:
        return state.set('pageViewQueue', List([]));

    case CLEAR_EVENT_QUEUE:
        return state.set('eventQueue', List([]));

    // Current page tracking
    case SET_CURRENT_PAGE:
        return state.set('currentPage', payload)
            .set('pageStartTime', Date.now());

    case CLEAR_CURRENT_PAGE:
        return state.set('currentPage', null)
            .set('pageStartTime', null);

    // Session state
    case SET_SESSION_ID:
        return state.set('sessionId', payload?.sessionId || null)
            .set('sessionStartedAt', payload?.startedAt || null);

    case CLEAR_SESSION:
        return state.set('sessionId', null)
            .set('sessionStartedAt', null)
            .set('currentPage', null)
            .set('pageStartTime', null)
            .set('pageViewQueue', List([]))
            .set('eventQueue', List([]));

    default:
        return state;
    }
}
